import React, { useState } from "react";
import { useAppContext, usePersistedState } from "../AppContext";
import { useTranslation } from "react-i18next";
import mainAxios from "../services/mainAxios";
import { toast } from "react-toastify";


export const SaleInvoicesContext = React.createContext(null);

export const useSaleInvoicesStore = () => React.useContext(SaleInvoicesContext);


export const SaleInvoicesContextProvider = ({ children }) => {
    const {
        company: [fullCompany],
    } = useAppContext();

    const { t } = useTranslation("translations");
    const [actionCisLoading,setActionCisLoading] = useState(false)

    
    const downloadByPeriod = ({filters,onSuccess})=>{
      setActionCisLoading(true)
      const loadingToastId=toast.loading(t("invoice.invoicesFromCisLoading"),{
        containerId: "all_toast",
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: false,
      })
      mainAxios.post("/apiEndpoint/invoices/from-cis-button",{
        params:{
          transactionType:"sales"
        },
        fromDate:filters.fromDate,
        toDate:filters.toDate,
        nuis:fullCompany.nuis
      }).then(res=>{
          setActionCisLoading(false)
          toast.dismiss(loadingToastId)
        if(res.data.status){
          onSuccess()
          toast.success(t("invoice.invoicesFromCisRetrieved"), {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "all_toast",
            });
        }
      })
      .catch(()=>{
          setActionCisLoading(false)
          toast.dismiss(loadingToastId)
      })
    }
    


    const store={
      downloadByPeriod,
      actionCisLoading,
      setActionCisLoading
    }

  return <SaleInvoicesContext.Provider value={store}>{children}</SaleInvoicesContext.Provider>;
};
